/**
 * Joins class names, dropping anything falsy.
 *
 * Deliberately NOT `clsx` + `tailwind-merge`, which is what shadcn/ui uses upstream. Those exist to
 * resolve CONFLICTING utilities — `px-4` passed over a component's own `px-2` — by knowing which
 * Tailwind classes occupy the same slot. GLADIS does not need that yet: every override at a call
 * site here is additive (`mt-6`, `w-full`, `ml-3`), and where two classes did collide the outcome
 * would be decided by stylesheet order rather than argument order regardless.
 *
 * Add `tailwind-merge` when a real conflict appears, not before — it is a non-trivial dependency
 * bought to solve a problem this codebase does not have.
 */
export function cn(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(" ");
}
